export default "__VITE_ASSET__BOtdYagJ__"